export const translate = (list, key, params) => {
  const keys = key.split('.')

  return list[keys[0]][keys[1]].replace(/\{{(\S+?)\}}/g, (match, ...args) => params[args[0]])
}

export const replaceData = (string, params) => {
  return string.replace(/\{{(\S+?)\}}/g, (match, ...args) => params[args[0]])
}

export const tl = replaceData

export const translateBack = (list, key, value) => {
  return Object.keys(list[key])[Object.values(list[key]).indexOf(value)]
}
